import { Menu } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { UserMenu } from "@/components/layout/UserMenu";

interface AuthenticatedTopBarProps {
  onMenuClick?: () => void;
}

export function AuthenticatedTopBar({ onMenuClick }: AuthenticatedTopBarProps) {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <header className="sticky top-0 z-40 h-14 flex items-center justify-between px-4 border-b bg-background/95 backdrop-blur print:hidden">
      {/* Hambúrguer: abre o drawer no mobile; no desktop a sidebar é fixa */}
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Abrir menu"
        className="md:hidden inline-flex items-center justify-center h-11 w-11 -ml-2 rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground"
      >
        <Menu className="h-6 w-6" />
      </button>
      {/* Spacer no desktop (sem hambúrguer) para manter o UserMenu à direita */}
      <div className="hidden md:block" />
      <UserMenu />
    </header>
  );
}

export default AuthenticatedTopBar;
